import React, { useState } from 'react';
import { Modal, Box, Content, Title, Table, Icon } from "rbx";
import PaginationCustom from './PaginationCustom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { cpfOrCnpjMask } from '../../commons/masks';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '3px'
}

const UserModalList = (props) => {
  const { activeModal, setActiveModal, listUsers, selectUser, userType } = props;
  const [pageOfItems, setPageOfItems] = useState([]);

  const toogle = () => { setActiveModal(!activeModal) };

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  return (
    <Modal closeOnBlur={true} closeOnEsc={true} active={activeModal} onClose={toogle}>
      <Modal.Background onClick={toogle} />
      <Modal.Content>
        <Box>
          <Content>
            <Title size={5} className="mb-4">
              Selecione um {userType} clicando no <Icon color="custom-purple"> <FontAwesomeIcon icon={faCheckCircle} size="sm" /> </Icon>
            </Title>  
            <hr style={ styleHr }/>
            <Table fullwidth>
              <Table.Body>
                {
                  pageOfItems.map((user, index) => (
                    <Table.Row key={user._id} onClick={() => selectUser(pageOfItems[index])}>
                      <Table.Cell textAlign="centered" width="55px">
                        <Icon color="custom-purple">
                          <FontAwesomeIcon icon={faCheckCircle} size="lg" style={{cursor: 'pointer'}} />
                        </Icon>
                      </Table.Cell>
                      <Table.Cell>
                        {cpfOrCnpjMask(user.cpf_cnpj)} - <strong>{user.name}</strong> <br/>
                        {user.email}
                      </Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
            </Table>
            <hr style={ styleHr }/>
            <PaginationCustom items={listUsers} onChangePage={onChangePage} pageSize={8} />
          </Content>
        </Box>
      </Modal.Content>
      <Modal.Close />
    </Modal>
  )

}

export default UserModalList;
